export default __webpack_public_path__ + "static/media/Stars.b7881ed5.svg";